{{ record[column.field] ? 'Yes' : 'No' }}
